
export default {
  props: {
    content: { type: String, required: true },
    label: { type: String, required: true }
  },
  computed: {
    // Split trusted locale HTML without a browser API so every paragraph is
    // present in the server response, including the collapsed continuation.
    introductionEnd () {
      const closing = /<\/p\s*>/i.exec(this.content)
      return closing ? closing.index + closing[0].length : this.content.length
    },
    intro () {
      return this.content.slice(0, this.introductionEnd)
    },
    remaining () {
      return this.content.slice(this.introductionEnd).trim()
    }
  }
}
